import {
  HomeIcon,
  UserGroupIcon,
  DocumentTextIcon,
  CalendarIcon,
  CurrencyDollarIcon,
  WrenchScrewdriverIcon,
  ClipboardDocumentListIcon,
  UserIcon,
  PercentBadgeIcon,
  BanknotesIcon,
  DocumentIcon,
  WalletIcon,
  DevicePhoneMobileIcon,
  FolderIcon,
  ChatBubbleLeftRightIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  LinkIcon,
  DocumentCheckIcon,
} from "@heroicons/react/24/outline";


export const SIDEBAR_NAV = [
  {
    title: "",
    items: [
      { path: "", label: "Dashboard", icon: HomeIcon, permission: undefined },
      {
        path: "live-chat",
        label: "Live Chat",
        icon: ChatBubbleOvalLeftEllipsisIcon,
        permission: "live_chat",
      },
      {
        path: "invoices",
        label: "Invoices",
        icon: CurrencyDollarIcon,
        permission: "view_invoices",
      },
      {
        path: "payments",
        label: "Payments",
        icon: BanknotesIcon,
        permission: "view_payments",
      },
      {
        path: "schedule",
        label: "Schedule",
        icon: CalendarIcon,
        permission: "view_schedule",
      },
      {
        path: "open-requests",
        label: "Open Quotes Requests",
        icon: ClipboardDocumentListIcon,
        permission: "open_quote_request",
      },
      {
        path: "surveyor",
        label: "Surveyor",
        icon: UserIcon,
        permission: ["view_surveyors", "add_surveyor", "update_surveyor", "delete_surveyor"],
      },
      {
        path: "offers-management",
        label: "Offers Management",
        icon: PercentBadgeIcon,
        permission: ["offers_management", "send_offer", "edit_offer", "delete_offer"],
      },
      {
        path: "user-agreement",
        label: "User Agreement",
        icon: DocumentCheckIcon,
        permission: ["offers_management", "send_offer", "edit_offer", "delete_offer"],
      },
      {
        path: "cash-requests",
        label: "Cash Requests",
        icon: BanknotesIcon,
        permission: ["view_cash_requests", "accept_cash_request", "reject_cash_request"],
      },
      {
        path: "surveyors-cash-requests",
        label: "Surveyors Cash",
        icon: WalletIcon,
        permission: ["view_surveyor_cash", "accept_surveyor_cash", "reject_surveyor_cash"],
      },
      {
        path: "category",
        label: "Category",
        icon: DevicePhoneMobileIcon,
        permission: ["view_categories", "create_category", "update_category", "delete_category"],
      },
      {
        path: "sub-category",
        label: "SubCategory",
        icon: FolderIcon,
        permission: ["view_categories", "create_category", "update_category", "delete_category"],
      },
      {
        path: "problem-reports",
        label: "Problem Reports",
        icon: DocumentTextIcon,
        permission: ["view_problem_reports", "create_problem_report", "update_problem_report", "delete_problem_report"],
      },
      {
        path: "team-member",
        label: "Team Member",
        icon: UserGroupIcon,
        permission: ["view_team_members", "create_team_member", "update_team_member", "delete_team_member"],
      },
      {
        path: "all-users",
        label: "All Users",
        icon: UserGroupIcon,
        permission: ["view_team_members"], 
      },
    ],
  },
  {
    title: "Data Management",
    items: [
      {
        path: "clients",
        label: "Clients",
        icon: UserGroupIcon,
        permission: ["view_clients", "create_client", "update_client", "delete_client"],
      },
      {
        path: "requests",
        label: "Requests",
        icon: DocumentTextIcon,
        permission: "view_quote",
      },
      {
        path: "quotes",
        label: "Quotes",
        icon: CurrencyDollarIcon,
        permission: "view_quote",
      },
      {
        path: "jobs",
        label: "Jobs",
        icon: WrenchScrewdriverIcon,
        permission: ["view_jobs", "create_job", "delete_job"],
      },
      {
        path: "reports",
        label: "Reports",
        icon: DocumentIcon,
        permission: ["view_reports", "approve_report"],
      },
      {
        path: "contact-messages",
        label: "Contact Messages",
        icon: ChatBubbleLeftRightIcon,
        permission: "view_contact_messages",
      },
      {
        path: "lead-sources",
        label: "Lead Sources",
        icon: LinkIcon,
        permission: ["view_categories", "view_quote"], // Needs its own slug later
      },
    ],
  },
];

